module.exports = __webpack_public_path__ + "img/b4c6659500d30d2caa9d46b9cf082e6f.svg";